import {DatePipe} from "@angular/common";
import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  ValidatorFn,
  Validators
} from "@angular/forms";
import {Router} from "@angular/router";
import {AppConfig} from "src/app/configs/app-config";
import {TipoParentescoEnum} from "src/app/core/enums/tipo-parentesco.enum";
import {DropdownLists} from "src/app/core/helpers/dropdown-lists/dropdown-lists";
import {ValidatorsCustom} from "src/app/core/helpers/validators-custom/validators-custom";
import {IBotonOpcion} from "src/app/core/models/formulario/boton-opcion.interface";
import {
  SolicitudAfiliacionObsoleta
} from "src/app/core/models/request/solicitud-afiliacion-obsoleta";
import {ApiCambioEstadoCivilInterface} from "src/app/core/models/response/api-cambio-estado-civil.interface";
import {SalarioConyuge} from "src/app/core/models/salario/salario-conyuge";
import {Pac, WresponseData} from "src/app/core/models/worker/wresponse-data";
import {GlobalService} from "src/app/core/services/global/global.service";
import {LocalStorageService} from "src/app/core/services/local-storage/local-storage.service";
import {ModalService} from "src/app/core/services/modal/modal.service";
import {ValidateData} from "src/app/core/utils/validate-data";
import {TipoIdentificacion} from "../../individual-afiliate-beneficiary/model/tipo-identificacion";
import {ListaTipoIdentificacion} from "../../individual-afiliate-beneficiary/model/tipo-identificacion.enum";
import {
  ValidacionesFechaNacimientoService
} from "../../individual-afiliate-beneficiary/services/validaciones-fecha-nacimiento.service";
import {ValidacionesService} from "../../individual-afiliate-beneficiary/services/validaciones.service";
import {SeleccionarNuevoEstadoComponent} from "../seleccionar-nuevo-estado/seleccionar-nuevo-estado.component";
import {
  obtenerSolicitudTipoId,
  SolicitudTiposEnum
} from "src/app/core/models/request/afiliaciones/solicitud-tipos.enum";
import {DetalleSolicitudModel} from "src/app/core/services/gestor/consultas/detalle-solicitud.model";
import {GestorSolicitudesConsultas} from "src/app/core/services/gestor/consultas/gestor-solicitudes-consultas.service";
import {ModalVariadoService} from "src/app/core/services/modal-variado/modal-variado.service";
import {RequestService} from "src/app/core/services/request/request.service";
import {BodyRequestValid} from "src/app/core/models/request/solicitud-valida";
import { IAffiliateBeneficiary, IAffiliateInformation, IAffiliateTitular, IBasicData } from 'src/app/core/models/affiliation/iaffiliate-process';
import { NgxSpinnerService } from "ngx-spinner";
import { IAfiliado, IPac, IValidataUser } from "src/app/core/models/user/user";
import { AffiliationService } from "src/app/core/services/affiliation/affiliation.service";
import { EstadoSolicitud } from "src/app/core/models/enum/estado-solicitud.enum";
import { take, takeUntil } from 'rxjs/operators';
import { Subject } from "rxjs";
import { ValidacionRadicacionSolicitudService } from 'src/app/core/services/api/validacion-radicacion-solicitud.service';

@Component({
    selector: "app-exponer-informacion",
    templateUrl: "./exponer-informacion.component.html",
    styleUrls: ["./exponer-informacion.component.scss"],
    standalone: false
})
export class ExponerInformacionComponent implements OnInit {
  @Input() estadoCivilSeleccionado: { codigo: string; desc: string };
  @Output() eventoHijo = new EventEmitter();
  @Input() form: FormGroup;
  @Input() datosAfiliado?: WresponseData;
  @Input() habilitarConyugeCuidador?: boolean;
  @Output() eventoValidar = new EventEmitter<void>();
  
  public solicitudesEnProcesoCEC: Array<any>;
  public coincidenciaEncontrada: boolean = false;
  public solicitudesDeAfiliadoCargadas: boolean = false;
  public datosConyuge: Pac = null;
  finalizaRequestSvc: boolean = false;
  reglasCambioEstadoCivil: any;
  public filterConyuge: any;
  estadoActual;
  private afiliacion: SolicitudAfiliacionObsoleta;
  public tieneInformacionAdicional: boolean;
  public tieneSeccionRadioButton: boolean;

  public idModal = "m-load";

  public tiposIdentificacion: Array<TipoIdentificacion>;
  public genders: { name: string; value: number }[] = DropdownLists.genders;
  public occupations: { name: string; value: string }[] =
    DropdownLists.occupations;
  public salaryTypes: { name: string; value: string }[] =
    DropdownLists.salaryTypes;
  public documentCompanies: { name: string; value: string }[] =
    DropdownLists.documentCompanies;
  public minimaFecha = new Date();
  public maximaFecha = new Date();
  public salarioMinimoConyuge: number;
  public salarioMaximoConyuge: number;
  public etiquetasRadioButton: IBotonOpcion[] = [
    {
      id: `"rbCambioEstadocivil1`,
      texto: "Sí, es la misma",
      ariaHidden: true,
      valor: "SI",
    },
    {
      id: `"rbCambioEstadocivil2`,
      texto: "NO, es diferente",
      ariaHidden: true,
      valor: "NO",
    },
  ];
  public dateFormat = new DatePipe("es-CO");
  public tieneSeccionDocumentos: boolean = true;
  public formRadioButton: FormGroup;

  public estadoRadioButton: boolean = false;
  private minimum_salary: number = 0;
  private infoConyugeAfiliado: IBasicData;
  private infoTitularAfiliado: IAffiliateTitular;
  private destroy$ = new Subject<void>();

  constructor(
    private fb: FormBuilder,
    private validacionesSvc: ValidacionesService,
    private validacionesFechaNacimientoSvc: ValidacionesFechaNacimientoService,
    private globalService: GlobalService,
    private modalSvc: ModalService,
    private router: Router,
    private obtenerFuncionesNuevoEstadoCivil: SeleccionarNuevoEstadoComponent,
    private localStorageService: LocalStorageService,
    private gestorSolicitudesConsultas: GestorSolicitudesConsultas,
    public _ModalVariadoService: ModalVariadoService,
    public requestService: RequestService,
    public _affiliateService: AffiliationService,
    private _spinner: NgxSpinnerService,
    private _validacionRadicacionSolicitudService: ValidacionRadicacionSolicitudService
  ) {
    this.infoConyugeAfiliado = {} as IBasicData;
    this.infoTitularAfiliado = {} as IAffiliateTitular;
  }

  ngOnInit() {


    // @ts-ignore
    this.minimum_salary = AppConfig.salarioMinimo(this.localStorageService);
    this.estadoActual =
      this.datosAfiliado.validacion_afiliado.afiliado.estadoCivil;
    this.tiposIdentificacion =
      this.validacionesSvc.obtenerDocumentosValidos_cambioEstadoCivil(
        this.datosAfiliado
      ).tiposIdentificacion.filter(tipo => tipo.valor != 'CO1P');

    if (this.datosAfiliado.validacion_afiliado.pacs) {
      this.filterConyuge = this.datosAfiliado.validacion_afiliado.pacs.filter(
        (x) => x.relacion.codigo === "SUB-0002"
      );
      if (this.filterConyuge.length > 0) {
        this.datosConyuge = this.filterConyuge[0];
      }
    }

    this.comportamiento();

    this.detectarCambiosEnFormulario();
    
    this._affiliateService.titularAfiliado$
    .pipe(takeUntil(this.destroy$))
    .subscribe(titular => {
      this.infoTitularAfiliado = titular ?? {} as IAffiliateTitular;
    });

    this._affiliateService.conyugeAfiliado$
    .pipe(takeUntil(this.destroy$))
    .subscribe(conyuge => {
      this.infoConyugeAfiliado = conyuge ?? {} as IBasicData;
    });

    if(this.form.get('cambioEstadoCivil')){
        this.form.get('cambioEstadoCivil')?.setValue(this.infoTitularAfiliado.numeroDocumento);
    }
  }

  private detectarCambiosEnFormulario() {
    const regex = /^(\d{6,8}|\d{10})$/;

    this.formConyuge
      .get("TipoIdConyuge")
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe((value: string) => {
      if (
        !this.formConyuge.get("TipoIdConyuge").disabled &&
        !ValidateData.emptyObject(value)
      ) {
        const reglaTipoDocumento = this.tiposIdentificacion.find(
          (x) => x.valor == value
        );
        this.formConyuge
          .get("NumIdConyuge")
          .setValidators([
            Validators.required,
            Validators.minLength(reglaTipoDocumento.min),
            Validators.maxLength(reglaTipoDocumento.max),
            Validators.pattern(reglaTipoDocumento.expresionRegular),
            ValidatorsCustom.validadorDocumentoDiferenteTrabajador(() => this.datosAfiliado?.validacion_afiliado.afiliado.numeroDocumento ?? '' ),
            ValidatorsCustom.documentoDiferenteTrabajador(() =>{
              const trabajadorId = this.form.get("trabajador.NumIdTrabajador");
              if (trabajadorId) {
                return trabajadorId.value;
              }
  
              return this.form.get("cambioEstadoCivil")?.value ?? null
              })
          ]);

        this.formConyuge.get("TipoIdConyuge").setValidators([Validators.required]);

        this.formConyuge.get("FechaNaciConyuge").enable();
        // Esta condicional es para habilitar la validación de fechas solo cuando se pueda editar el formulario
        if (this.tieneInformacionAdicional) {
          this.obtenerValidacionRangoDeEdad(value);
          this.formConyuge
            .get("TipoIdEmpresaConyuge")
            .valueChanges.subscribe((value: string) => {
            if (!ValidateData.emptyObject(value)) {
              let validaciones;
              if (value == "CO1N") {
                let varRegex = /^[0-9]{9}$/;
                validaciones = ValidatorsCustom.patternCustom(
                  varRegex,
                  "Debe contener 9 digitos"
                );
              } else {
                let reglaTipoDocumento = this.tiposIdentificacion.find(
                  (x) => x.valor == value
                );
                validaciones = Validators.pattern(
                  reglaTipoDocumento.expresionRegular
                );
              }
              this.formConyuge.get("NumIdEmpresaConyuge").clearValidators();
              this.formConyuge
                .get("NumIdEmpresaConyuge")
                .setValidators([Validators.required, validaciones]);
              this.formConyuge
                .get("NumIdEmpresaConyuge")
                .updateValueAndValidity();
            }
          });
        }
      }
    });

    this.formConyuge
    this.formConyuge
      .get("OcupacionConyuge")
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe((value: string) => {
      if (
        !this.formConyuge.get("TipoIdConyuge").disabled &&
        !ValidateData.emptyObject(value)
      ) {
        this.cambioTipoDeOcupacion(value);
      }
    });

    this.formConyuge
      .get("TipoSalarioConyuge")
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe((value: number) => {
      if (!ValidateData.emptyObject(value)) {
        this.cambiarRangoSalario(value);
      }
    });


    this.formConyuge
      .get("NumIdEmpresaConyuge")
      .valueChanges.subscribe((value: string) => {
      if (!ValidateData.emptyString(value)) {
        this.calculateDigVerC(value);
      }
    });

    this.formConyuge
      .get("Apellido1Conyuge")
      .valueChanges.subscribe((value: string) => {
      this.formConyuge
        .get("Apellido1Conyuge")
        .setValue(value ? value.toUpperCase() : "", {emitEvent: false});
    });

    this.formConyuge
      .get("Apellido2Conyuge")
      .valueChanges.subscribe((value: string) => {
      this.formConyuge
        .get("Apellido2Conyuge")
        .setValue(value ? value.toUpperCase() : "", {emitEvent: false});
    });

    this.formConyuge
      .get("Nombre1Conyuge")
      .valueChanges.subscribe((value: string) => {
      this.formConyuge
        .get("Nombre1Conyuge")
        .setValue(value ? value.toUpperCase() : "", {emitEvent: false});
    });
    this.formConyuge
      .get("Nombre2Conyuge")
      .valueChanges.subscribe((value: string) => {
      this.formConyuge
        .get("Nombre2Conyuge")
        .setValue(value ? value.toUpperCase() : "", {emitEvent: false});
    });


    this.formConyuge.get("RazonEmpresaConyuge").clearValidators();
    this.formConyuge.get("NumIdEmpresaConyuge").setValidators([Validators.required]);
    this.formConyuge.get("NumIdEmpresaConyuge").updateValueAndValidity();
    this.formConyuge.get("RazonEmpresaConyuge")
      .valueChanges.subscribe((value: string) => {
      this.formConyuge
        .get("RazonEmpresaConyuge")
        .setValue(value ? value.toUpperCase() : null, {emitEvent: false});
    });


    this.cambiarEstadoCampoFormulario("TipoSalarioConyuge", false, "");

    let regext = /^\d*$/;

    this.cambiarEstadoCampoFormulario("SalarioConyuge", true, "", [
      ValidatorsCustom.patternCustom(regext,
        "El valor ingresado no debe tener caracteres especiales"
      ),
    ]);

    this.formConyuge.get("SalarioConyuge").valueChanges.subscribe((value: number) => {
      const tipoSalario = this.determinarTipoSalario(value);
      this.cambiarEstadoCampoFormulario("TipoSalarioConyuge", false, tipoSalario);
    });
  }

  determinarTipoSalario(salario: number): string {
    const rangosSalarioConyuge = SalarioConyuge.obtenerSalarioConyuge(this.localStorageService);
    const SALARIO_MINIMO_ESPECIAL = rangosSalarioConyuge["01"].salarioMinimo;
    return salario >= SALARIO_MINIMO_ESPECIAL ? "01" : "02";
  }

  private cambioTipoDeOcupacion(value: string) {
    // Empleado(a)
    this.cambiarEstadoCampoFormulario("TipoIdEmpresaConyuge", false, "");
    this.cambiarEstadoCampoFormulario("NumIdEmpresaConyuge", false, "");
    this.cambiarEstadoCampoFormulario("RazonEmpresaConyuge", false, "");
    this.cambiarEstadoCampoFormulario("TipoSalarioConyuge", false, "");
    this.cambiarEstadoCampoFormulario("SalarioConyuge", false, "");

    if (value === "02") {
      this.cambiarEstadoCampoFormulario("TipoIdEmpresaConyuge", true, "", [
        Validators.required,
      ]);
      this.cambiarEstadoCampoFormulario("NumIdEmpresaConyuge", true, "", [
        Validators.required,
      ]);
      this.cambiarEstadoCampoFormulario("RazonEmpresaConyuge", true, "", [
        Validators.required,
        Validators.maxLength(40),
        Validators.pattern("^[a-zA-Z0-9]([^s]?[a-zA-Z0-9])+$"),
      ]);
      this.cambiarEstadoCampoFormulario("SalarioConyuge", true, "");
      this.cambiarEstadoCampoFormulario("TipoSalarioConyuge", false, "");
      return;
    }

    // Hogar o Desempleado
    if (value === "01" || value === "04") {
      this.cambiarEstadoCampoFormulario("TipoSalarioConyuge", false, "");
      return;
    }

    // Independiente o Pensionado(a)
    if (value === "03" || value === "05") {
      this.cambiarEstadoCampoFormulario("SalarioConyuge", true, "", [
        Validators.required,
      ]);
      this.cambiarEstadoCampoFormulario("TipoIdEmpresaConyuge", false, "");
      this.cambiarEstadoCampoFormulario("NumIdEmpresaConyuge", false, "");
      this.cambiarEstadoCampoFormulario("RazonEmpresaConyuge", false, "");
      this.cambiarEstadoCampoFormulario("TipoSalarioConyuge", false, "02");
      return;
    }
  }

  private cambiarEstadoCampoFormulario(
    key: string,
    isEnable: boolean,
    value: any,
    arrayValidations?: ValidatorFn[]
  ) {
    if (isEnable) {
      this.formConyuge.get(key).enable();
    }
    if (!isEnable) {
      this.formConyuge.get(key).disable();
    }
    this.formConyuge.get(key).setValue(value);
    this.formConyuge.get(key).clearValidators();
    if (arrayValidations) {
      this.formConyuge.get(key).setValidators(arrayValidations);
    }
    this.formConyuge.get(key).markAsUntouched();
    this.formConyuge.get(key).updateValueAndValidity();
  }


  cambiarRangoSalario(value) {
    if (value) {
      const rangosSalarioConyuge = SalarioConyuge.obtenerSalarioConyuge(this.localStorageService);
      this.salarioMinimoConyuge = rangosSalarioConyuge[value].salarioMinimo;
      this.salarioMaximoConyuge = rangosSalarioConyuge[value].salarioMaximo;
      this.formConyuge
        .get("SalarioConyuge")
        .setValidators([
          Validators.required,
          ValidatorsCustom.validarRangoSalarioConyuge(
            this.salarioMinimoConyuge,
            this.salarioMaximoConyuge
          ),

        ]);
    }
  }


  showCalendar(event: any) {
    document.getElementById(event.target.id).click();
  }

  /**
   * Funcion para calcular el digito de verificacion de una empresa dependiendo de su nit
   * @param nit Nit de la empresa
   */
  calculateDigVerC(nit: string) {
    let codV;
    if (nit) {
      codV = this.globalService.calculerDV(nit);
    }
    this.formConyuge.get("DigVerEmpresaConyuge").setValue(codV);
    this.formConyuge.get("DigVerEmpresaConyuge").updateValueAndValidity();
  }

  regresarEstado() {
    this.formConyuge.reset();
    this.eventoHijo.emit();
  }

  comportamiento() {
    this.reglasCambioEstadoCivil =
      this.obtenerFuncionesNuevoEstadoCivil.reglasEstadoCivil(
        this.estadoActual,
        this.estadoCivilSeleccionado
      );
    this.tieneInformacionAdicional =
      this.reglasCambioEstadoCivil.tieneInformacionAdicional;
    this.tieneSeccionRadioButton =
      this.reglasCambioEstadoCivil.tieneSeccionRadioButton;

    if (!this.tieneInformacionAdicional) {
      if (this.filterConyuge) {
        this.setearValoresParaFormulario();
      }
    }

    if (this.tieneSeccionRadioButton) {
      this.formRadioButton = this.fb.group({});
      this.formRadioButton.addControl(
        "esCorrectoConyuge",
        this.fb.control(null, Validators.required)
      );
      let conyuge = this.formConyuge as FormGroup;
      conyuge.addControl("formRadioButton", this.formRadioButton);
      this.tieneSeccionDocumentos = true;

      this.formConyuge
        .get("formRadioButton")
        .get("esCorrectoConyuge")
        .valueChanges.subscribe((data) => {
        data === "SI"
          ? (this.tieneSeccionDocumentos = true)
          : (this.tieneSeccionDocumentos = true);
        data === "NO"
          ? (this.estadoRadioButton = true)
          : (this.estadoRadioButton = true);
      });
    }
  }

  setearValoresParaFormulario() {


    this.formConyuge.reset({
      reason: this.reglasCambioEstadoCivil.idJson,
      TipoIdConyuge: this.datosConyuge.tipoDocumento,
      NumIdConyuge: this.datosConyuge.numeroDocumento,
      Apellido1Conyuge: this.datosConyuge.apellido,
      Apellido2Conyuge: this.datosConyuge.segundoApellido,
      Nombre1Conyuge: this.datosConyuge.primerNombre,
      Nombre2Conyuge: this.datosConyuge.segundoNombre,
      FechaNaciConyuge: this.dateFormat.transform(this.datosConyuge.fechaNacimiento, "yyyy-MM-dd", "+0100"),
      GeneroConyuge: this.datosConyuge.genero,
    });
    this.formConyuge.disable();
  }

  private obtenerValidacionRangoDeEdad(value: string) {
    this.formConyuge.get("FechaNaciConyuge").setValue(null);
    let minimaFechaYMaximaFecha: any;
    if (value) {
      minimaFechaYMaximaFecha =
        this.validacionesFechaNacimientoSvc.reglasSegunParentescoYDocumentoDeIndentificacion(
          this.datosAfiliado,
          TipoParentescoEnum.CONYUGE,
          this.formConyuge.get("TipoIdConyuge").value,
          "false"
        );


      this.minimaFecha = !ValidateData.emptyObject(minimaFechaYMaximaFecha)
        ? minimaFechaYMaximaFecha.fechaDesde
        : null;

      this.maximaFecha = !ValidateData.emptyObject(minimaFechaYMaximaFecha)
        ? minimaFechaYMaximaFecha.fechaHasta
        : null;

      this.formConyuge
        .get("FechaNaciConyuge")
        .setValidators([
          Validators.required,
          ValidatorsCustom.validarFechaMinimoYMaximo(
            this.minimaFecha,
            this.maximaFecha
          ),
        ]);
    }
  }

  get formConyuge() {
    return this.form.get("conyuge") as FormGroup;
  }

  onlyAllowNumbers(event: KeyboardEvent) {
    const inputChar = String.fromCharCode(event.charCode);
    const isDigit = /^\d$/.test(inputChar);
    const input = event.target as HTMLInputElement;
    if (!isDigit || input.value.length >= 9) {
      event.preventDefault();
    }
  }

/*   checkAndValidate() {
    this.eventoValidar.emit();
  } */

  async obtenerSolicitudesDeCambioEstadoCivil(tipoIdentidadBeneficiario: String, numeroIdentidadBeneficiario: String) {
    this.solicitudesEnProcesoCEC = [];
    const tipoSolicitudId = obtenerSolicitudTipoId(SolicitudTiposEnum.AFB);
    const solicitudesCM = await this.obtenerSolicitudesPorTipo(tipoIdentidadBeneficiario, numeroIdentidadBeneficiario, tipoSolicitudId);
    const solicitudesEnProceso = solicitudesCM.filter(item => item.numeroDocumentoBeneficiario.includes(numeroIdentidadBeneficiario)
      && item.solicitudesEntity?.numeroIdentidadTitular.includes(this.datosAfiliado.validacion_afiliado.afiliado.numeroDocumento)
      && item.solicitudesEntity?.tipoIdentidadTitular.includes(this.datosAfiliado.validacion_afiliado.afiliado.tipoDocumento)).length;
    if (solicitudesEnProceso > 0) {
      this.coincidenciaEncontrada = true;
      this._ModalVariadoService.modalAlerta('Este beneficiario ya tiene una solicitud en curso o se encuentra afiliado');
      this.formConyuge.reset();
    }

    this.solicitudesDeAfiliadoCargadas = true;
  }

  async obtenerSolicitudesPorTipo(tipoIdentidadBeneficiario, numeroIdentidadBeneficiario: any, tiposSolicitud: number): Promise<any> {
    const fechaDesde = new Date();
    fechaDesde.setMonth(fechaDesde.getMonth() - 2);
    fechaDesde.setHours(0, 0, 0, 0);

    const fechaHasta = new Date();
    fechaHasta.setHours(23, 59, 59, 999);
    const desde = fechaDesde.toISOString();
    const hasta = fechaHasta.toISOString();
    const portal = 2;
    const estados = [EstadoSolicitud.EN_PROCESO,
      EstadoSolicitud.DEVOLUCION,
      EstadoSolicitud.DEVOLUCION_SUBSANADA,
      EstadoSolicitud.APROBADO,
      EstadoSolicitud.APROBADO_PARCIAL,
      EstadoSolicitud.COMPLETADO_PARCIAL,
      EstadoSolicitud.EN_VALIDACION_INTERNA];
    try {
      const resp: DetalleSolicitudModel[] = await this.gestorSolicitudesConsultas.obtenerSolicitudesPorTipoYEstados(tipoIdentidadBeneficiario,
        numeroIdentidadBeneficiario,
        desde,
        hasta,
        tiposSolicitud,
        portal,
        estados
      ).toPromise();
      return resp;

    } catch (error) {
      console.error('Ocurrió un error al consultar la solicitudes: ', error);
      return [];
    }
  }

  public onBlurAfiliado(){
    const typeDocument =  this.formConyuge.get("TipoIdConyuge").value;
    const document = this.formConyuge.get("NumIdConyuge").value;
    this.iniciarBusquedaAfiliado(typeDocument, document);
  }

  private iniciarBusquedaAfiliado(typeDocument: string, document: string) {
    if(typeDocument != '' && document  != ''){
      this._spinner.show();
      if(this.infoTitularAfiliado && typeDocument === this.infoTitularAfiliado.tipoDocumento && document === this.infoTitularAfiliado.numeroDocumento){
        this._spinner.hide();
        return;
      }

      if(!this.buscarDatosResponse(typeDocument, document)){
        this.buscarDatosAfiliado(typeDocument, document);
      }else{
        this._spinner.hide();
      }
    }
  }

  private buscarDatosAfiliado(typeDocument: string, document: string) {
    this._affiliateService.getInfoAffiliateBasic(typeDocument, document).subscribe(
      (response: IAffiliateInformation | null) => {
        this.limpiarDatosFormulario();
        if (response) {
          const afiliadoSearch = response.informacionAfiliado;
          const beneficiariosSearch = response.informacionBeneficiario;
          if(afiliadoSearch.numeroDocumento == document && afiliadoSearch.tipoDocumento == typeDocument){
            this.llenarFormularioAfiliado(afiliadoSearch);
            this.infoConyugeAfiliado = afiliadoSearch;
            this._affiliateService.actualizarConyuge(afiliadoSearch);
          }
          else{
            const beneficiarioEncontrado = beneficiariosSearch.find(beneficiario => beneficiario.numeroDocumento == document && beneficiario.tipoDocumento == typeDocument);
            if(beneficiarioEncontrado){
              this.llenarFormularioAfiliado(beneficiarioEncontrado);
              this.infoConyugeAfiliado = beneficiarioEncontrado;
              this._affiliateService.actualizarConyuge(beneficiarioEncontrado);
            }

          }
        }
        this._spinner.hide();
    });
    
  }

  private buscarDatosResponse(typeDocument: string, document: string): Boolean {
    const afiliadoData = this.datosAfiliado.validacion_afiliado.afiliado;
    const beneficiariosData = this._affiliateService.mapBeneficiarios(this.datosAfiliado.validacion_afiliado.pacs);
    if(afiliadoData.numeroDocumento == document && afiliadoData.tipoDocumento == typeDocument){
      this.llenarFormularioAfiliado(afiliadoData);
      this.infoConyugeAfiliado = afiliadoData;
      this._affiliateService.actualizarConyuge(afiliadoData);
      return true;
    }
    else{
      const beneficiarioEncontrado = 
        beneficiariosData.find(beneficiario => beneficiario.numeroDocumento == document && beneficiario.tipoDocumento == typeDocument);
      if(beneficiarioEncontrado){
        this.llenarFormularioAfiliado(beneficiarioEncontrado);
        this.infoConyugeAfiliado = beneficiarioEncontrado;
        this._affiliateService.actualizarConyuge(beneficiarioEncontrado);
        return true;
      }
      return false;
    }
  }

  private llenarFormularioAfiliado(afiliado: IAfiliado | IPac | IAffiliateTitular | IAffiliateBeneficiary): void {
      const fechaISO = afiliado.fechaNacimiento;
      const fechaFormateada = fechaISO?.split('T')[0] ?? '';
      
      this.formConyuge.get('Nombre1Conyuge')?.setValue(afiliado.primerNombre);
      this.formConyuge.get('Nombre2Conyuge')?.setValue(afiliado.segundoNombre);
      if('apellido' in afiliado){
        this.formConyuge.get('Apellido1Conyuge')?.setValue(afiliado.apellido);
      }
      else{
        this.formConyuge.get('Apellido1Conyuge')?.setValue(afiliado.primerApellido);
      }
      this.formConyuge.get('Apellido2Conyuge')?.setValue(afiliado.segundoApellido);
      this.formConyuge.get('GeneroConyuge')?.setValue(afiliado.genero);

      const fechaControl = this.formConyuge.get('FechaNaciConyuge');
      fechaControl.setValue(fechaFormateada);
      fechaControl.markAsTouched();
      fechaControl.updateValueAndValidity();

      this._spinner.hide();
  }

  private limpiarDatosFormulario() {
    const afilaido: Partial<IAffiliateBeneficiary> = {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      fechaNacimiento: '',
      genero: '',
      parentesco: ''
    };
    this.llenarFormularioAfiliado(afilaido as IAffiliateBeneficiary);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}

